import { Injectable, Injector } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { lastValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AppConfigService {

  public settings: any;

  constructor(private http: HttpClient) {}

  public load(): Promise<any> {
    const jsonFile = 'assets/config.json';
    const config$ = this.http.get(jsonFile);
    
    return lastValueFrom(config$)
      .then(config => {
        this.settings = config;
      })
      .catch((err: any) => {
        console.error("Erro ao carregar o arquivo de configuração", err);
      });
  }
}